import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { request } from '@/utils/request1';
import APIURL from '@/api/apiUrl1';

// 获取布告列表
export function getNoticeList(params) {
  var data = _objectSpread({
    pageSize: 10,
    pageIndex: 1
  }, params);

  //   Object.assign(data, query)
  //   return request.post(APIURL.energy.list, data)
  return request.post(APIURL.energy.list, data);
}

// 获取布告详情
export function getNoticeInfo(id) {
  var data = {
    id: id
  };
  return request.get(APIURL.energy.info, data);
}

// 修改布告数据
export function updateNoticeInfo(params) {
  var data = _objectSpread({}, params);
  return request.post(APIURL.energy.update, data);
}